import { render, staticRenderFns } from "./TheReportCard.vue?vue&type=template&id=3996cf5c&scoped=true&"
import script from "./TheReportCard.vue?vue&type=script&lang=js&"
export * from "./TheReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996cf5c",
  null
  
)

export default component.exports